import { BaseEvent } from '@kiplin/web-common/event';

export type AuthenticationRequiredEventData = {
  statusCode: number;
  url: string | null;
};

export class AuthenticationRequiredEvent extends BaseEvent<AuthenticationRequiredEventData> {
  public static getKey(): string {
    return 'authentication-required';
  }

  public constructor(init: CustomEventInit<AuthenticationRequiredEventData>) {
    super(AuthenticationRequiredEvent.getKey(), init);
  }
}
